<template>
  <div class="emd-card">
    <div class="emd-card__header">
      <div class="emd-app-icon" :style="`background-color: ${item.color}`">
        <img class="emd-app-icon__image" :src="item.avatar" :alt="item.name">
      </div>
    </div>
    <div class="emd-card__content">
      <h6 class="emd-text _color_primary _size_section">{{item.name}}</h6>
      <div class="emd-card__aside">
        <span class="emd-badge _color_success" v-if="item.last_review_status === 'Approved'">{{ $t('home.app.states.approved') }}</span>
        <span class="emd-badge _color_info" v-if="item.last_review_status === 'ApprovedAsFutureApp'">{{ $t('home.app.states.futureApp') }}</span>
        <span class="emd-badge _color_danger" v-if="item.last_review_status === 'Reproved'">{{ $t('home.app.states.reproved') }}</span>
        <span class="emd-badge _color_warning" v-if="item.last_review_status === 'PendingReview'">{{ $t('home.app.states.pendingReview') }}</span>
      </div>
    </div>
    <div class="emd-card__footer">
      <div class="emd-flex">
        <div class="emd-flex-item _grow_1 _align_bottom">
          <router-link class="emd-btn _color_secondary _type_outline _block _size_small"
          :to="{ name: 'application', params: { publicAppKey: item.public_app_key} }">
            <i class="uil uil-pen"></i>
            {{ $t('home.app.edit') }}
          </router-link>
        </div>
        <div class="emd-flex-item _grow_1 _align_bottom">
          <router-link class="emd-btn _color_danger _type_outline _block _size_small"
          :to="{ name: 'delete-application', params: { publicAppKey: item.public_app_key} }">
            <i class="uil uil-trash-alt"></i>
            {{ $t('home.app.delete') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: ['item']
}
</script>
